const PAGE_TYPE = {
    H5: 1,
    PC: 10
};

export function isPc() {
    let route = null;
    if (window.FEGORender) {
        const { store } = window.FEGORender;
        route = store.route;
    } else {
        const {
            app: { project }
        } = window.FEGOEditor;
        route = project.route;
    }
    return route?.now.pageType === PAGE_TYPE.PC;
}
